(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notoy-downloads"] && !Shopify.designMode) return;
  try {
    
// NOTOY Downloads — même origine : téléchargement NATIF (attribut download, fiable, garde le geste utilisateur).
// Cross-origin uniquement (ex. cdn.shopify.com via file_url) : fetch -> blob, sinon ouvre l'image.
document.querySelectorAll('[data-notoy-dl]').forEach(function (link) {
  link.addEventListener('click', function (event) {
    var sameOrigin;
    try {
      sameOrigin = new URL(link.href, window.location.href).origin === window.location.origin;
    } catch (e) {
      sameOrigin = true;
    }
    if (sameOrigin) {
      link.removeAttribute('target'); // pas d'onglet fantôme : le natif télécharge directement
      return;
    }
    if (!window.fetch || !window.URL || !URL.createObjectURL) return;
    event.preventDefault();
    var url = link.getAttribute('href');
    var name = link.getAttribute('data-filename') || 'notoy-wallpaper.jpg';
    link.classList.add('is-loading');
    fetch(url, { mode: 'cors' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.blob();
      })
      .then(function (blob) {
        var a = document.createElement('a');
        var objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 4000);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      })
      .then(function () {
        link.classList.remove('is-loading');
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notoy-owners"] && !Shopify.designMode) return;
  try {
    
// NOTOY Owners — force le téléchargement des wallpapers exclusifs (fetch -> blob), sinon ouvre l'image
document.querySelectorAll('[data-notoy-dl]').forEach(function (link) {
  link.addEventListener('click', function (event) {
    if (!window.fetch || !window.URL || !URL.createObjectURL) return;
    event.preventDefault();
    var url = link.getAttribute('href');
    var name = link.getAttribute('data-filename') || 'notoy-wallpaper.jpg';
    fetch(url, { mode: 'cors' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.blob();
      })
      .then(function (blob) {
        var a = document.createElement('a');
        var objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 4000);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
